import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ListFilterService {

    public searchTerm: string;
    public searchTerm$: Subject<string> = new Subject<string>();

    constructor() {
    }

    public filterList(searchTerm: string, list: Array<any>, filterFunction?: (value: any, index: number) => boolean) {
        this.searchTerm = searchTerm;

        if (!filterFunction) {
            // domyślna funkcja do filtrowania stringów
            filterFunction = (value, index) => {
                return value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
            }
        }

        // timeout żeby pogrubianie tekstów wykonało się po wyrenderowaniu przefiltrowanej listy
        setTimeout(() => {
            this.searchTerm$.next(this.searchTerm);
        });

        return list.filter(filterFunction);

    }
}
